/**
 * The test console's types (docs/features/quote-to-invoice-e2e-testing/07 §1): the wire shapes of
 * `/journey-testing/*` and `/xero/simulated/*`, aliased from the generated schema, plus the console's own
 * request inputs. Lists come back as the canonical `ListResponse`.
 */

import type { components } from "./api-schema.generated";

type Schemas = components["schemas"];

export type PreviewClock = Schemas["ClockResponse"];
export type PreviewClockAdvanced = Schemas["ClockAdvancedResponse"];
export type PreviewJobRun = Schemas["JobRunResponse"];
export type PreviewJobs = Schemas["JobsResponse"];
export type ScenarioRecipe = Schemas["RecipeResponse"];
export type ScenarioRun = Schemas["ScenarioRunResponse"];
export type ScenarioRunDetail = Schemas["ScenarioRunDetailResponse"];
export type ScenarioRunSupplier = Schemas["ScenarioRunSupplierResponse"];
export type ScenarioRunStep = Schemas["ScenarioStepResponse"];
export type ScenarioRunLink = Schemas["ScenarioLinkResponse"];
export type OutboxMessageSummary = Schemas["OutboxMessageSummaryResponse"];
export type OutboxMessage = Schemas["OutboxMessageResponse"];
export type SupplierMessage = Schemas["SupplierMessageResponse"];
export type SupplierPurchaseOrder = Schemas["SupplierPurchaseOrderResponse"];
export type SupplierPurchaseOrderGroup =
  Schemas["SupplierPurchaseOrderGroupResponse"];
export type SupplierSignInPerson = Schemas["SupplierSignInPersonResponse"];
export type SupplierSignInLink = Schemas["SupplierSignInLinkResponse"];
export type SupplierOrderLink = Schemas["SupplierOrderLinkResponse"];
export type SupplierEventInput = Schemas["SupplierEventRequest"];
export type SupplierEventKind = SupplierEventInput["kind"];
export type SupplierMessageMode = NonNullable<SupplierEventInput["mode"]>;
export type SimulatedXeroDocument = Schemas["SimulatedXeroDocumentResponse"];
export type SimulatedXeroDocumentType = SimulatedXeroDocument["document_type"];
export type SimulatedXeroFailNextInput =
  Schemas["FailNextSimulatedXeroCallRequest"];
export type BrandHubOrderInput = Schemas["BrandHubOrderRequest"];
export type BrandHubOrderSent = Schemas["BrandHubOrderResponse"];
export type BrandHubStatus = Schemas["BrandHubStatusResponse"];
export type InboundMailInput = Schemas["InboundMailRequest"];
export type InboundMailOutcome = Schemas["InboundMailResponse"];
export type CustomerSignInLink = Schemas["CustomerSignInLinkResponse"];
export type TestingPreviewEntry = Schemas["TestingPreviewExchangeResponse"];

export interface RunScenarioInput {
  recipe: string;
  /** One of the recipe's stages; its last when omitted. */
  stopAt?: string;
}

export interface OutboxListOptions {
  page?: number;
  pageSize?: number;
  /** The recipient, exactly. */
  to?: string;
  scenarioRunId?: string;
  /** Searches the subject. */
  q?: string;
}

export interface SimulatedXeroDocumentListOptions {
  page?: number;
  pageSize?: number;
  documentType?: SimulatedXeroDocumentType;
  q?: string;
}

/** The fast-forward choices the console offers (07 §1); custom days are 1–90. */
export const FAST_FORWARD_PRESETS: ReadonlyArray<{
  label: string;
  days: number;
}> = [
  { label: "1 day", days: 1 },
  { label: "3 days", days: 3 },
  { label: "1 week", days: 7 },
];

export const SUPPLIER_EVENT_LABELS: Record<SupplierEventKind, string> = {
  placed: "Placed",
  despatched: "Despatched",
  delivered: "Delivered",
  short_delivered: "Short-delivered",
  cancelled: "Cancel",
  line_cancelled: "Cancel line",
};
